// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICardStatusBriefRecordDto
 */
export interface ICardStatusBriefRecordDto {
    /**
     * 
     * @type {number}
     * @memberof ICardStatusBriefRecordDto
     */
    total_active_cards?: number;
    /**
     * 
     * @type {number}
     * @memberof ICardStatusBriefRecordDto
     */
    total_pending_activation_cards?: number;
}

/**
 * Check if a given object implements the ICardStatusBriefRecordDto interface.
 */
export function instanceOfICardStatusBriefRecordDto(value: object): value is ICardStatusBriefRecordDto {
    return true;
}

export function ICardStatusBriefRecordDtoFromJSON(json: any): ICardStatusBriefRecordDto {
    return ICardStatusBriefRecordDtoFromJSONTyped(json, false);
}

export function ICardStatusBriefRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICardStatusBriefRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_active_cards': json['total_active_cards'] == null ? undefined : json['total_active_cards'],
        'total_pending_activation_cards': json['total_pending_activation_cards'] == null ? undefined : json['total_pending_activation_cards'],
    };
}

export function ICardStatusBriefRecordDtoToJSON(json: any): ICardStatusBriefRecordDto {
    return ICardStatusBriefRecordDtoToJSONTyped(json, false);
}

export function ICardStatusBriefRecordDtoToJSONTyped(value?: ICardStatusBriefRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total_active_cards': value['total_active_cards'],
        'total_pending_activation_cards': value['total_pending_activation_cards'],
    };
}

